export const flexFlowStyle = (flexFlow: string) => {
  return {
    WebkitFlexFlow: flexFlow,
    flexFlow: flexFlow
  }
};

export const flexChildStyle = (size: string) => {
  const splitSize = size.trim().split(/[\s]+/);
  const splitCount = splitSize.length;

  let flex = size;

  // Contains value when only one word passed (e.g. auto, 60px)
  if (splitCount === 1) {
    const sizeOnly = splitSize[0];
    const splitSizeOnly = sizeOnly.split(/([\d]+)(.*)/);
    const num = splitSizeOnly[1];
    const units = splitSizeOnly[2];
    const isPassThrough = num === undefined;
    const isGrowRatio = units === '%' || units === '' || units === undefined;
    const grow = isGrowRatio ? num : '0';
    const shrink = isGrowRatio ? '1' : '0';
    const basis = isGrowRatio ? '0px' : size;
    if (sizeOnly && !isPassThrough) {
      flex = grow + ' ' + shrink + ' ' + basis;
    }
  }

  return {
    WebkitFlex: flex,
    flex: flex,
  }
};

export const justifyStyle = (justify: string) => {
  let justifyValue;

  switch (justify) {
    case 'start':
      justifyValue = 'flex-start';
      break;

    case 'end':
      justifyValue = 'flex-end';
      break;

    case 'center':
      justifyValue = 'center';
      break;

    case 'between':
      justifyValue = 'space-between';
      break;

    case 'around':
      justifyValue = 'space-around';
      break;

    default:
      justifyValue = 'flex-start';
  }

  return {
    WebkitJustifyContent: justifyValue,
    justifyContent: justifyValue
  }
};

export const alignStyle = (attribute: string, align: string) => {
  let alignValue;

  switch (align) {
    case 'start':
      alignValue = 'flex-start';
      break;

    case 'end':
      alignValue = 'flex-end';
      break;

    case 'center':
      alignValue = 'center';
      break;

    case 'baseline':
      alignValue = 'baseline';
      break;

    case 'stretch':
      alignValue = 'stretch';
      break;

    default:
      alignValue = 'stretch';
  }

  const style: any = {};
  style[attribute] = alignValue;
  return style;
};

export const scrollStyle = (attribute: string, scroll: string) => {
  let scrollValue;

  switch (scroll) {
    case 'auto':
      scrollValue = 'auto';
      break;

    case 'off':
      scrollValue = 'hidden';
      break;

    case 'on':
      scrollValue = 'scroll';
      break;

    case 'spill':
      scrollValue = 'visible';
      break;

    default:
      scrollValue = 'auto'
  }

  const style: any = {};
  style[attribute] = scrollValue;
  return style;
};
